import React, { useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, Link, useRouteMatch } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import { TopMenuStyle } from './style';

const TopMenu = () => {
  const { path } = useRouteMatch();

  const userId = useSelector(state => state?.auth?.userId);
  useLayoutEffect(() => {
    console.log(userId);
    const active = document.querySelector('.strikingDash-top-menu a.active');
    const activeDefault = () => {
      const megaMenu = active.closest('.megaMenu-wrapper');
      const hasSubMenuLeft = active.closest('.has-subMenu-left');
      if (!megaMenu) {
        active.closest('ul').previousSibling.classList.add('active');
        if (hasSubMenuLeft) hasSubMenuLeft.closest('ul').previousSibling.classList.add('active');
      } else {
        active.closest('.megaMenu-wrapper').previousSibling.classList.add('active');
      }
    };
    window.addEventListener('load', active && activeDefault);
    return () => window.removeEventListener('load', activeDefault);
  }, []);

  const addParentActive = event => {
    document.querySelectorAll('.parent').forEach(element => {
      element.classList.remove('active');
    });

    const hasSubMenuLeft = event.currentTarget.closest('.has-subMenu-left');
    const megaMenu = event.currentTarget.closest('.megaMenu-wrapper');
    if (!megaMenu) {
      event.currentTarget.closest('ul').previousSibling.classList.add('active');
      if (hasSubMenuLeft) hasSubMenuLeft.closest('ul').previousSibling.classList.add('active');
    } else {
      event.currentTarget.closest('.megaMenu-wrapper').previousSibling.classList.add('active');
    }
  };
  return (
    <TopMenuStyle>
      <div className="strikingDash-top-menu">
        <ul>
          <li>
            <Link to={`${path}/pages/create-shipment`} className="parent">
              สร้างพัสดุ
            </Link>
          </li>
          <li>
            <Link to={`${path}/pages/shipments`} className="parent">
              ติดตามพัสดุ
            </Link>
          </li>
          <li>
            <Link to={`${path}/pages/pickups`} className="parent">
              ใบรับพัสดุ
            </Link>
          </li>
            <li>
              <Link to={`${path}/pages/bill_invoice`} className="parent">
                บิลชำระ
              </Link>
            </li>
          {userId && (userId == 11442 || userId == 65127 || userId == 62712) ? (
            <li>
              <Link to={`${path}/pages/dropoff`} className="parent">
                รับพัสดุ Dropoff
              </Link>
            </li>
          ) : (
            <></>
          )}
          {/* <li>
          <Link to={`${path}/pages/bills`} className="parent">
            รายการรอบบิลชำระ
          </Link>
          </li> */}
        </ul>
      </div>
    </TopMenuStyle>
  );
};

export default TopMenu;
